<script>
import { mapActions } from 'vuex';
import FileUpload from './FileUpload.vue';

export default {
  components: {
    FileUpload,
  },
  props: {
    name: {
      default: '',
      type: String,
    },
    knowledgebase: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      editableName: this.name,
    };
  },
  computed: {
    filePlaceholder() {
      return this.$t('LIBRARIES.RECORDS.NAME.PLACEHOLDER');
    },
  },
  watch: {
    name(newName) {
      this.editableName = newName;
    },
  },
  methods: {
    ...mapActions('records', ['get']),
    onDelete() {
      this.$emit('delete');
    },
    saveArticle() {
      this.$emit('save');
    },
    updateName() {
      this.$emit('update-name', this.editableName);
    },
  },
};
</script>

<template>
  <div
    class="flex justify-between items-center h-14 min-h-[3.5rem] px-4 py-2 bg-white dark:bg-slate-900 border-b border-slate-50 dark:border-slate-800/50"
  >
    <h1
      class="text-2xl mb-0 flex items-center text-slate-900 dark:text-slate-100"
    >
      <woot-sidemenu-icon />
      <fluent-icon
        icon="book"
        class="mr-2 ml-1 rtl:ml-2 rtl:mr-1 hidden md:block header--icon icon book"
      />
      <input
        v-model="editableName"
        :placeholder="filePlaceholder"
        class="text-slate-900 font-medium text-2xl dark:text-slate-100 bg-transparent border-none focus:outline-none"
        @input="updateName"
      />
    </h1>
    <div class="justify-end flex">
      <woot-button
        size="medium"
        color-scheme="warning"
        variant="clear"
        icon="delete"
        class="ml-2"
        @click="onDelete"
      >
        {{ $t('LIBRARIES.RECORDS.REMOVE.LONG_LABEL') }}
      </woot-button>
      <woot-button
        size="medium"
        color-scheme="primary"
        icon="save"
        class="ml-2"
        @click="saveArticle"
      >
        {{ $t('LIBRARIES.RECORDS.SAVE.LABEL') }}
      </woot-button>
    </div>
  </div>
</template>
